import { fleetRecordPath } from '../../fleet.paths';

/** A truck's own page gives each tab its own route, `/fleet/trucks/:id/<tab>` (`recordTabRoutes`). */
export const TRUCK_TABS = ['details', 'documents', 'ownership', 'service-plan', 'service-records', 'history'] as const;
export type TruckTab = (typeof TRUCK_TABS)[number];

export const TRUCK_TAB_LABELS: Record<TruckTab, string> = {
  details: 'Details',
  documents: 'Documents',
  ownership: 'Ownership',
  'service-plan': 'Service plan',
  'service-records': 'Service records',
  history: 'History',
};

export function truckTabPath(id: string, tab: TruckTab): string {
  return `${fleetRecordPath('trucks', id)}/${tab}`;
}

/** The two tabs that need `maintenance.view`. */
export function isServiceTab(tab: TruckTab): boolean {
  return tab === 'service-plan' || tab === 'service-records';
}
